export default "__VITE_ASSET__C5XnHm1Y__"